import React from "react";
import ForecastTable from "../../Components/ForecastTable/ForecastTable";

const WeatherPage = () => {
  return <ForecastTable />;
};

export default WeatherPage;
